/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_OkInputs */

const en_admin_questionnaire_editor_ok = /** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const nl_admin_questionnaire_editor_ok = /** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const de_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const es_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const it_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/** @type {(inputs: Admin_Questionnaire_Editor_OkInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_ok = en_admin_questionnaire_editor_ok;

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Admin_Questionnaire_Editor_OkInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_ok = /** @type {((inputs?: Admin_Questionnaire_Editor_OkInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_OkInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_ok(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_ok(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_ok(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_ok(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_ok(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_ok(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_ok(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_ok(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_ok(inputs)
	return ro_admin_questionnaire_editor_ok(inputs)
});
export { admin_questionnaire_editor_ok as "admin.questionnaire_editor.ok" }